import { initializeConnector } from '@salesforce/scv-connector-base';
import { ScvConnector } from '@main/sf-connector/scv-connector';
import { EventListenerFacade } from '@main/event-listeners/event-listener-facade';
import { Logger } from '@main/utils/logger';
import { BusLayer } from '@main/bus-layer/bus-layer';

console.log('Hello SCV connector');

const connector = new ScvConnector();
window.addEventListener('load', async () => {
  const eventListenerFacade = new EventListenerFacade(new Logger());
  eventListenerFacade.initEventListeners();
  initializeConnector(connector);
  BusLayer.init().then(console.log);
});
